import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["apiKeyField", "toggleButton"]
  static values = { 
    apiKey: String,
    webhookUrl: String
  }

  connect() {
    this.apiKeyVisible = false
  }

  toggleApiKeyVisibility() {
    if (this.hasApiKeyFieldTarget) {
      const field = this.apiKeyFieldTarget
      const button = this.toggleButtonTarget
      
      if (this.apiKeyVisible) {
        field.type = "password"
        button.innerHTML = this.getShowIcon()
        this.apiKeyVisible = false
      } else {
        field.type = "text"
        button.innerHTML = this.getHideIcon()
        this.apiKeyVisible = true
      }
    }
  }

  copyApiKey() {
    this.copyToClipboard(this.apiKeyValue, "API key copied to clipboard!")
  }

  copyWebhookUrl() {
    this.copyToClipboard(this.webhookUrlValue, "Webhook URL copied to clipboard!")
  }

  copyToClipboard(text, message) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        this.showNotification(message, "success")
      }).catch(err => {
        console.error('Failed to copy:', err)
        this.showNotification("Failed to copy to clipboard", "error")
      })
    } else {
      // Fallback for older browsers
      const textArea = document.createElement("textarea")
      textArea.value = text
      textArea.style.position = "fixed"
      textArea.style.left = "-999999px"
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      
      try {
        document.execCommand('copy')
        this.showNotification(message, "success")
      } catch (err) {
        console.error('Failed to copy:', err)
        this.showNotification("Failed to copy to clipboard", "error")
      }
      
      document.body.removeChild(textArea)
    }
  }

  showNotification(message, type = "info") {
    // Create toast notification
    const toast = document.createElement("div")
    toast.className = `alert alert-${type} fixed bottom-4 right-4 z-50 w-auto min-w-[200px] shadow-lg`
    toast.innerHTML = `
      <div>
        <span>${message}</span>
      </div>
    `
    
    document.body.appendChild(toast)
    
    // Auto-remove after 3 seconds
    setTimeout(() => {
      toast.remove()
    }, 3000)
  }

  getShowIcon() {
    return `<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
    </svg>`
  }

  getHideIcon() {
    return `<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
    </svg>`
  }
}